import React, { use, useEffect, useState }  from "react";

import { TableRow, TableCell, IconButton, Collapse, CardContent } from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box } from "@mui/system";
import OrderInfo from "views/pages/orders/detail/info";
import { getOrderDetail } from "services/orderServices";

const initFilter = {
    page: 0,
    limit: 20,
}

function RowComponent({
  row,
  rowId,
  rowWidth,
  tableRowDetail
}) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    _id: null,
    description: "",
    eventName: "",
    oldEventName: "",
    classLink: ""
  });
  const [filter, setFilter] = useState(initFilter)

  useEffect(() => {
    if (open && form._id === null) {
      loadMerchantInfo(rowId)
    }
  }, [filter])

  useEffect(() => {
    if (open && form._id === null) {
      loadMerchantInfo(rowId)
    }
  }, [open])

  useEffect(() => {

  }, [form])

  const loadMerchantInfo = async(id) => {
    let { data, error } = await getOrderDetail({
      _id: id,
      page: filter.page,
      limit: filter.limit,
    })
    if (error) {}
    if (data) {
      setForm({
        ...data,
        oldEventName: data.eventName
      })
    }
  }

  return (
    <React.Fragment>
      <TableRow
        key={row._id}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        {
          Object.keys(row).map((value, index) => {
              return <TableCell sx={ rowWidth && rowWidth[value] ? {
                  minWidth: `${rowWidth[value]} !important`,
                  width: `${rowWidth[value]}`,
                  py: 0.8, px: 1
              } : {py: 0.8, px: 1}}>
                { index === 0 && 
                  <Box sx={{ display: "flex", alignItems: "center", gap:1 }}>
                    <IconButton
                      aria-label="expand row"
                      size="medium"
                      onClick={() => setOpen(!open)}
                    >
                      {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                    {row[value]}
                  </Box>
                  
                }
                { index !== 0 && row[value]}
              </TableCell>
          })
        }
      </TableRow>
      <TableRow>
        <TableCell 
          style={{ paddingBottom: 0, paddingTop: 0 }} 
          sx={{ borderBottom: (open ? "1px solid #e0e0e0" : "none") }} 
          colSpan={Object.keys(row).length}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <CardContent>
              <OrderInfo 
                data={form}
                page={filter.page}
                onPageChange={(e) => {
                    setFilter({
                        page: e.page
                    })
                }}
                />
            </CardContent>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default RowComponent